import { useParams } from 'react-router-dom';

import OrderClientEntryPoints from '#app/entrypoints/orderClient';
import { useCollectionPaginated } from '#app/hooks/useCollectionPaginated';
import { OrderClientListByClient } from '#app/typings/orderClient';

type HookReturn = Omit<ReturnType<typeof useCollectionPaginated<OrderClientListByClient>>, 'filters' | 'setFilters'>;

const useOrderClients = (): HookReturn => {
  const { uuid } = useParams<{ uuid: string }>();
  return useCollectionPaginated<OrderClientListByClient>(
    OrderClientEntryPoints.getCollectionByClient,
    { sorting: { sortName: 'createdAt', sortDirection: 'desc' } },
    { uuid: uuid as string },
  );
};

export default useOrderClients;
